import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, plannerName, isDeleting }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-card border border-border rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-start space-x-4">
          {/* Icon */}
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" />
          </div>

          {/* Content */}
          <div className="flex-1">
            <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
              Delete Planner
            </h3>
            <p className="font-body text-sm text-muted-foreground mb-4">
              Are you sure you want to delete <span className="font-semibold text-foreground">"{plannerName}"</span>?
            </p>
            <div className="bg-muted/50 border border-border rounded-lg p-3 mb-4">
              <p className="font-caption text-xs text-muted-foreground">
                <Icon name="Info" size={14} className="inline mr-1" />
                This action cannot be undone. The planner will still count toward your total number of planners created.
              </p>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-end space-x-3">
              <Button
                variant="outline"
                size="sm"
                onClick={onClose}
                disabled={isDeleting}
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                size="sm"
                onClick={onConfirm}
                disabled={isDeleting}
                iconName={isDeleting ? "Loader2" : "Trash2"}
                iconPosition="left"
                iconSize={14}
              >
                {isDeleting ? 'Deleting...' : 'Delete Planner'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;